import { render, staticRenderFns } from "./TheCreateCode.vue?vue&type=template&id=73b65068&scoped=true"
import script from "./TheCreateCode.vue?vue&type=script&lang=js"
export * from "./TheCreateCode.vue?vue&type=script&lang=js"
import style0 from "./TheCreateCode.vue?vue&type=style&index=0&id=73b65068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b65068",
  null
  
)

export default component.exports